import { Icon, IconProps } from './Icon';

interface AddLinkIconProps extends IconProps {
  gradient?: {
    id: string;
    stops: { offset: string; color: string }[];
  };
}

export const AddLinkIcon = ({ color = '#5E6A81', gradient, ...props }: AddLinkIconProps) => (
  <Icon
    {...props}
    viewBox="0 0 25 24"
  >
    <defs>
      {gradient && (
        <linearGradient
          id={gradient.id}
          x1="80%"
          y1="20%"
          x2="20%"
          y2="80%"
        >
          {gradient.stops.map((stop, index) => (
            <stop
              key={index}
              offset={stop.offset}
              stopColor={stop.color}
            />
          ))}
        </linearGradient>
      )}
    </defs>
    <path
      d="M15.7128 12.7874C15.3979 12.4725 15.0242 12.2227 14.6128 12.0522C14.2014 11.8818 13.7605 11.7941 13.3152 11.7941C12.87 11.7941 12.4291 11.8818 12.0177 12.0522C11.6063 12.2227 11.2325 12.4725 10.9177 12.7874L7.49273 16.2131C6.857 16.849 6.49991 17.7113 6.5 18.6103C6.50009 19.5094 6.85737 20.3717 7.49323 21.0073C8.12909 21.643 8.99144 22.0001 9.89059 22C10.7897 21.9999 11.652 21.6427 12.2877 21.0068L12.6087 20.7029M12.2877 16.2131C12.6026 16.528 12.9763 16.7778 13.3877 16.9483C13.7991 17.1187 14.24 17.2064 14.6853 17.2064C15.1305 17.2064 15.5715 17.1187 15.9828 16.9483C16.3942 16.7778 16.768 16.528 17.0828 16.2131L20.5068 12.7874C21.1426 12.1517 21.4999 11.2894 21.5 10.3904C21.5001 9.49128 21.143 8.62898 20.5073 7.99316C19.8715 7.35734 19.0093 7.00009 18.1101 7C17.211 6.99991 16.3486 7.35698 15.7128 7.99266L14.6848 8.9536"
      stroke={gradient ? `url(#${gradient.id})` : color}
      strokeWidth="1.3"
      strokeLinecap="round"
      fill="none"
    />
    <path
      d="M6.5 4V8M4.5 6H8.5"
      stroke={gradient ? `url(#${gradient.id})` : color}
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
  </Icon>
);
